import styled from 'styled-components'

const ModuleDates = styled.div `
    width: max-content;
    display: flex;
    flex-direction: column;
`

export default ModuleDates;